import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "product-menu" };
const _hoisted_2 = {
    key: 0,
    class: "loading-container"
};
const _hoisted_3 = { class: "loading-text" };
const _hoisted_4 = {
    key: 1,
    class: "products-grid"
};
const _hoisted_5 = { class: "product-info" };
const _hoisted_6 = { class: "product-name" };
const _hoisted_7 = { class: "product-description" };
const _hoisted_8 = { class: "product-actions" };
const _hoisted_9 = { class: "add-to-cart-btn divers-btn" };
const _hoisted_10 = { class: "product-image" };
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = {
    key: 0,
    class: "gluten-badge"
};
const _hoisted_13 = { class: "product-info" };
const _hoisted_14 = { class: "product-name" };
const _hoisted_15 = {
    key: 0,
    class: "product-description"
};
const _hoisted_16 = {
    key: 1,
    class: "customize-section"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
    key: 2,
    class: "size-selection"
};
const _hoisted_19 = { class: "size-grid" };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { class: "size-name" };
const _hoisted_22 = { class: "product-actions" };
const _hoisted_23 = { class: "price-section" };
const _hoisted_24 = { class: "price" };
const _hoisted_25 = {
    key: 0,
    class: "delivery-price-indicator"
};
const _hoisted_26 = { class: "action-buttons" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
    key: 0,
    class: "empty-state"
};
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import htmlToText from "@/utils/html-to-text";
// @ts-ignore
import AdditionalFeaturesModal from "../modals/AdditionalFeaturesModal.vue";
// @ts-ignore
import BaseSupplementsModal from "../modals/BaseSupplementsModal.vue";
// @ts-ignore
import CreatePizzaModal from "../modals/CreatePizzaModal.vue";
// @ts-ignore
import DiversItemModal from "../modals/DiversItemModal.vue";
const PROMO_CATEGORY_ID = "250499e9-b59a-4c92-bd17-640a23368bb1";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductMenu',
    props: {
        category: {},
        searchQuery: {},
        products: {},
        isLoading: { type: Boolean },
        ingredients: {}
    },
    emits: ["add-to-cart", "customize-product", "add-divers-item"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const { t } = useI18n();
        const selectedSizes = ref({});
        const showDiversModal = ref(false);
        const shouldShowSizesForCategory = (product) => {
            // Use the display_sizes variable from the category if available
            if (product.categorieID?.display_sizes !== undefined) {
                const displaySizes = product.categorieID.display_sizes;
                // Handle both numeric (1/0) and boolean values
                if (displaySizes === 1 || displaySizes === true) {
                    return true;
                }
                // If explicitly set to false/0, return false even if it's a pizza
                if (displaySizes === 0 || displaySizes === false) {
                    return false;
                }
            }
            const category = product.categorieID;
            if (Number(category?.prio) === 1 ||
                category?.prio === true ||
                category?.is_recommended === 1 ||
                category?.is_recommended === true) {
                return true;
            }
            const categoryName = product.categorieID?.name?.toLowerCase() || "";
            if (categoryName.includes("pizza")) {
                return true;
            }
            if (categoryName.includes("boisson") ||
                categoryName.includes("drink") ||
                categoryName.includes("beverage")) {
                return true;
            }
            return false;
        };
        const filteredProducts = computed(() => {
            let filtered = props.products || [];
            if (props.category && !props.searchQuery.trim()) {
                filtered = filtered.filter((product) => {
                    const categoryMatch = product.categorieID?.id === props.category;
                    return categoryMatch;
                });
            }
            if (props.searchQuery.trim()) {
                const query = props.searchQuery.toLowerCase().trim();
                filtered = filtered.filter((product) => product.name.toLowerCase().includes(query) ||
                    (product.description &&
                        product.description.toLowerCase().includes(query)));
            }
            filtered = filtered.sort((a, b) => {
                return a.name.localeCompare(b.name, "fr", {
                    numeric: true,
                    sensitivity: "base",
                });
            });
            return filtered;
        });
        const isPizzaCategory = computed(() => {
            const query = props.searchQuery.toLowerCase();
            if (query.includes("pizza"))
                return true;
            // Also check if any of the products in the current list belong to a special/pizza category
            return filteredProducts.value.some(product => {
                const cat = product.categorieID;
                return (Number(cat?.prio) === 1 ||
                    cat?.prio === true ||
                    cat?.is_recommended === 1 ||
                    cat?.is_recommended === true ||
                    cat?.name?.toLowerCase().includes("pizza"));
            });
        });
        const classicPizzaSizes = ref([
            { id: "classic-small", size: "Petite", price: "14.00" },
            { id: "classic-medium", size: "Normale", price: "16.00" },
            { id: "classic-large", size: "Grande", price: "28.00" },
        ]);
        const glutenFreePizzaSizes = ref([
            { id: "gluten-free-medium", size: "Normale", price: "18.00" },
        ]);
        const isCreateYourPizzaCategory = (product) => {
            const categoryName = product.categorieID?.name?.toLowerCase() || "";
            return (categoryName.includes("créer votre pizza") ||
                categoryName.includes("create your pizza") ||
                categoryName.includes("pizza personnalisée"));
        };
        const getSpecializedCategoryType = (product) => {
            const category = product.categorieID;
            if (!category)
                return "none";
            if (Number(category.prio) === 1 ||
                category.is_recommended === 1 ||
                category.is_recommended === true) {
                return "pizza";
            }
            return "none";
        };
        const requiresSpecializedModal = (product) => {
            return getSpecializedCategoryType(product) !== "none";
        };
        const requiresCustomization = (product) => {
            return (requiresSpecializedModal(product) ||
                (product.additionnal && product.additionnal.length > 0));
        };
        const shouldShowCustomizeButton = (product) => {
            if (isCreateYourPizzaCategory(product)) {
                return false;
            }
            const category = product.categorieID;
            if (Number(category?.prio) === 1 ||
                category?.prio === true ||
                category?.is_recommended === 1 ||
                category?.is_recommended === true) {
                return true;
            }
            return false;
        };
        const getCustomizeButtonText = (product) => {
            const categoryType = getSpecializedCategoryType(product);
            switch (categoryType) {
                case "pizza":
                    return t('pos.customize');
                case "pasta":
                    return t('forms.addParmesan');
                case "salad":
                    return t('forms.addSauces');
                default:
                    return t('pos.customize');
            }
        };
        const getSortedProductSizes = (product) => {
            const sizes = product.sizes;
            if (sizes && Array.isArray(sizes) && sizes.length > 0) {
                return [...sizes].sort((a, b) => {
                    const order = ["Petite", "Normale", "Grande"];
                    const secondOrder = ["33cl", "0.5l", "1.5l"];
                    const thirdOrder = ["24cm", "33cm", "40cm"];
                    const compareInOrder = (orderArr) => {
                        const aName = a.name || a.size || "";
                        const bName = b.name || b.size || "";
                        const aIndex = orderArr.indexOf(aName);
                        const bIndex = orderArr.indexOf(bName);
                        if (aIndex !== -1 && bIndex !== -1)
                            return aIndex - bIndex;
                        if (aIndex !== -1)
                            return -1;
                        if (bIndex !== -1)
                            return 1;
                        return 0;
                    };
                    // User preference: 1 in middle, 2 on left, 3 on right => [2, 1, 3]
                    if (a.position !== undefined && b.position !== undefined) {
                        const customOrder = { 2: 0, 1: 1, 3: 2 };
                        const aPosOrder = customOrder[a.position] ?? a.position + 10;
                        const bPosOrder = customOrder[b.position] ?? b.position + 10;
                        if (aPosOrder !== bPosOrder)
                            return aPosOrder - bPosOrder;
                    }
                    return (compareInOrder(order) ||
                        compareInOrder(secondOrder) ||
                        compareInOrder(thirdOrder) ||
                        (a.name || a.size || "").localeCompare(b.name || b.size || ""));
                });
            }
            if (!product.productSizes)
                return [];
            return [...product.productSizes].sort((a, b) => {
                const order = ["Petite", "Normale", "Grande"];
                const secondOrder = ["33cl", "0.5l", "1.5l"];
                const thirdOrder = ["24cm", "33cm", "40cm"];
                const compareInOrder = (orderArr) => {
                    const aIndex = orderArr.indexOf(a.size);
                    const bIndex = orderArr.indexOf(b.size);
                    if (aIndex !== -1 && bIndex !== -1)
                        return aIndex - bIndex;
                    if (aIndex !== -1)
                        return -1;
                    if (bIndex !== -1)
                        return 1;
                    return 0;
                };
                // User preference: 1 in middle, 2 on left, 3 on right => [2, 1, 3]
                if (a.position !== undefined && b.position !== undefined) {
                    const customOrder = { 2: 0, 1: 1, 3: 2 };
                    const aPosOrder = customOrder[a.position] ?? a.position + 10;
                    const bPosOrder = customOrder[b.position] ?? b.position + 10;
                    if (aPosOrder !== bPosOrder)
                        return aPosOrder - bPosOrder;
                }
                return (compareInOrder(order) ||
                    compareInOrder(secondOrder) ||
                    compareInOrder(thirdOrder) ||
                    a.size.localeCompare(b.size));
            });
        };
        const getProductImage = (product) => {
            const image = product.image;
            if (image) {
                return image;
            }
            if (product.image_urls?.[0]) {
                return product.image_urls[0];
            }
            return "/imgs/products/default-product.png";
        };
        const formatPrice = (price) => {
            return `${price.toFixed(2)} CHF`;
        };
        const hasSizes = (product) => {
            const sizes = product.sizes;
            const hasProductSizes = (sizes && Array.isArray(sizes) && sizes.length > 0) ||
                (product.productSizes && product.productSizes.length > 0);
            if (!hasProductSizes) {
                return false;
            }
            return shouldShowSizesForCategory(product);
        };
        const hasMultipleSizes = (product) => {
            const sizes = product.sizes;
            const hasMultipleProductSizes = (sizes && Array.isArray(sizes) && sizes.length > 1) ||
                (product.productSizes && product.productSizes.length > 1);
            if (!hasMultipleProductSizes) {
                return false;
            }
            return shouldShowSizesForCategory(product);
        };
        const getDefaultSize = (sizes) => {
            if (sizes.length === 0)
                return null;
            // Prioritize position 1 as per user request
            const positionOne = sizes.find((s) => s.position === 1);
            if (positionOne)
                return positionOne;
            const preferredSize = sizes.find((s) => s.name === "Normale" ||
                s.name === "0,5L" ||
                s.name === "0.5L" ||
                s.name?.toLowerCase().includes("normale") ||
                s.name?.toLowerCase().includes("0.5"));
            if (preferredSize)
                return preferredSize;
            const middleIndex = Math.floor(sizes.length / 2);
            return sizes[middleIndex];
        };
        const getSelectedSize = (product) => {
            const selected = selectedSizes.value[product.id];
            if (selected) {
                return selected;
            }
            const sizes = product.sizes;
            if (sizes && Array.isArray(sizes) && sizes.length > 0) {
                const defaultSize = getDefaultSize(sizes);
                if (defaultSize) {
                    selectedSizes.value[product.id] = defaultSize;
                    return defaultSize;
                }
            }
            else if (product.productSizes && product.productSizes.length > 0) {
                const transformedSizes = product.productSizes.map(transformProductSize);
                const defaultSize = getDefaultSize(transformedSizes);
                if (defaultSize) {
                    selectedSizes.value[product.id] = defaultSize;
                    return defaultSize;
                }
            }
            return null;
        };
        const currentOrderType = computed(() => store.getters["orderType/selectedOrderType"] || "dine_in");
        const productPrices = computed(() => {
            const orderType = currentOrderType.value;
            const prices = {};
            props.products.forEach((product) => {
                const selectedSize = getSelectedSize(product);
                let basePrice = 0;
                if (selectedSize) {
                    basePrice = orderType === "delivery"
                        ? Number(selectedSize.priceLivraison || selectedSize.price || 0)
                        : Number(selectedSize.price || selectedSize.priceLivraison || 0);
                }
                else {
                    const sizes = product.sizes || product.productSizes || [];
                    if (sizes.length > 0) {
                        const firstSize = sizes[0];
                        const p = firstSize.price || firstSize.takeawayPrice || 0;
                        const pl = firstSize.priceLivraison || firstSize.deliveryPrice || p;
                        basePrice = orderType === "delivery" ? Number(pl) : Number(p);
                    }
                }
                prices[product.id] = basePrice || 0;
            });
            return prices;
        });
        watch(currentOrderType, (newOrderType, oldOrderType) => { }, {
            immediate: false,
        });
        watch(currentOrderType, () => {
        }, { immediate: false });
        const transformProductSize = (size) => {
            return {
                id: size.id || "",
                name: size.size,
                size: size.size,
                price: size.price || size.takeawayPrice || "0",
                priceLivraison: size.priceLivraison || size.deliveryPrice || size.price || size.takeawayPrice || "0",
                position: size.position,
                created_at: new Date().toISOString(),
            };
        };
        const parsePhpSerializedAdditionnal = (serialized) => {
            if (!serialized)
                return [];
            const matches = serialized.match(/s:\d+:"(.*?)";/g);
            if (!matches)
                return [];
            return matches
                .map((match) => {
                const valueMatch = match.match(/s:\d+:"(.*?)";/);
                return valueMatch && valueMatch[1] ? valueMatch[1] : "";
            })
                .filter((item) => typeof item === "string" && item.length > 0);
        };
        const normalizeAdditionnal = (additionnal) => {
            const ensureArray = (items) => items
                .map((item) => {
                if (typeof item === "string")
                    return item.trim();
                if (item &&
                    typeof item === "object" &&
                    "name" in item) {
                    // Return the full object if valid
                    return item;
                }
                if (item === null || item === undefined)
                    return "";
                return String(item).trim();
            })
                .filter((item) => {
                if (typeof item === 'string')
                    return item.length > 0;
                return !!item;
            });
            if (!additionnal)
                return [];
            if (Array.isArray(additionnal)) {
                return ensureArray(additionnal);
            }
            if (typeof additionnal === "string") {
                const trimmed = additionnal.trim();
                if (!trimmed)
                    return [];
                if (/^a:\d+:\{/.test(trimmed)) {
                    const parsed = parsePhpSerializedAdditionnal(trimmed);
                    if (parsed.length > 0) {
                        return ensureArray(parsed);
                    }
                }
                try {
                    const parsed = JSON.parse(trimmed);
                    if (Array.isArray(parsed)) {
                        return ensureArray(parsed);
                    }
                }
                catch (error) {
                }
                if (trimmed.includes(",")) {
                    return ensureArray(trimmed.split(","));
                }
                return ensureArray([trimmed]);
            }
            return [];
        };
        const transformProduct = (product) => {
            return {
                id: product.id,
                name: product.name,
                description: product.description,
                image: getProductImage(product),
                category: product.categorieID?.id || "",
                sizes: product.productSizes?.map(transformProductSize) || [],
                ingredients: product.Ingredients?.map((ing) => ({
                    id: ing.id,
                    name: ing.name,
                    price: parseFloat(ing.extra_cost_price?.toString() || "0"),
                    isDefault: ing.isDefault,
                    isAvailable: ing.isAvailable,
                    image: ing.imageUrl,
                })) || [],
                baseIngredients: product.ingredientdeBases?.map((ing) => ({
                    id: ing.id,
                    name: ing.name,
                    image: ing.image_url,
                    isAvailable: ing.is_available === 1 || ing.is_available === true,
                    isDefault: ing.is_default === "1" || ing.is_default === true,
                    price: parseFloat(ing.extra_cost_price || "0"),
                    extra_cost_price: parseFloat(ing.extra_cost_price || "0"),
                    type: ing.type,
                })) || [],
                supplements: [],
                isAvailable: product.isAvailable,
                isPopular: product.isVedette,
                type: product.type,
                withoutGluten: product.isSelected,
                additionnal: normalizeAdditionnal(product.additionnal),
                ingredientsBaseNames: product.ingredientsBaseNames || [],
                categorieID: product.categorieID,
            };
        };
        const handleSizeSelection = (product, size) => {
            selectedSizes.value[product.id] = transformProductSize(size);
        };
        const handleCustomize = (product) => {
            if (isCreateYourPizzaCategory(product)) {
                if (product.productSizes && product.productSizes.length > 0) {
                    createPizzaSizes.value = product.productSizes.map(transformProductSize);
                }
                currentPizzaProduct.value = product;
                currentPizzaProductId.value = product.id;
                const selectedSize = getSelectedSize(product);
                currentPizzaSelectedSize.value = selectedSize;
                showCreatePizzaModal.value = true;
                return;
            }
            const transformedProduct = transformProduct(product);
            const selectedSize = getSelectedSize(product);
            emit("customize-product", {
                product: transformedProduct,
                selectedSize: selectedSize,
            });
        };
        const handleQuickAdd = (product, preTransformedProduct) => {
            const transformedProduct = preTransformedProduct ?? transformProduct(product);
            const selectedSize = getSelectedSize(product);
            // Check for supplementsBases first
            const supplementsBases = product.supplementsBases ||
                product.supplementBase ||
                [];
            if (Array.isArray(supplementsBases) && supplementsBases.length > 0) {
                // Add supplementsBases to the transformed product for the modal
                const productWithSupplements = {
                    ...transformedProduct,
                    supplementsBases: supplementsBases,
                    category_name: product.categorieID?.name || "",
                };
                baseSupplementsModalProduct.value = productWithSupplements;
                baseSupplementsModalSize.value = selectedSize;
                showBaseSupplementsModal.value = true;
                return;
            }
            if (transformedProduct.additionnal &&
                transformedProduct.additionnal.length > 0) {
                additionalModalProduct.value = transformedProduct;
                additionalModalSize.value = selectedSize;
                showAdditionalModal.value = true;
                return;
            }
            if (selectedSize) {
                const addToCartEvent = {
                    product: transformedProduct,
                    size: selectedSize,
                    quantity: 1,
                    ingredients: [],
                    supplements: [],
                    notes: "",
                };
                emit("add-to-cart", addToCartEvent);
            }
        };
        const handleDiversConfirm = (item) => {
            showDiversModal.value = false;
            emit("add-divers-item", item);
        };
        const showAdditionalModal = ref(false);
        const additionalModalProduct = ref(null);
        const additionalModalSize = ref(null);
        const showBaseSupplementsModal = ref(false);
        const baseSupplementsModalProduct = ref(null);
        const baseSupplementsModalSize = ref(null);
        const showCreatePizzaModal = ref(false);
        const createPizzaSizes = ref([]);
        const createPizzaIngredients = computed(() => {
            if (!props.ingredients || props.ingredients.length === 0) {
                return [];
            }
            const mapProductSizeToVariationSize = (productSizeName) => {
                const sizeName = productSizeName?.toLowerCase() || "";
                if (sizeName.includes("grande") || sizeName.includes("large")) {
                    return "Grande";
                }
                if (sizeName.includes("normale") || sizeName.includes("normal")) {
                    return "Normale";
                }
                return "unique";
            };
            const getIngredientPriceForSize = (ingredient, productSize = "Normale") => {
                if (!ingredient)
                    return 0;
                if (ingredient.is_default === true ||
                    ingredient.is_default === 1 ||
                    ingredient.id?.startsWith("base-")) {
                    return 0;
                }
                if (ingredient.price_variations &&
                    Array.isArray(ingredient.price_variations)) {
                    let variationSize = "unique";
                    if (productSize && typeof productSize === "object" && productSize.position !== undefined) {
                        // Priority 1: Map based on position
                        const positionMap = {
                            1: "Normale",
                            2: "Petite",
                            3: "Grande"
                        };
                        variationSize = positionMap[productSize.position] || "unique";
                    }
                    else if (productSize) {
                        // Priority 2: Fallback to name-based mapping
                        const sizeName = typeof productSize === "string" ? productSize : productSize.size || productSize.name;
                        variationSize = mapProductSizeToVariationSize(sizeName || "Normale");
                    }
                    let priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === variationSize.toLowerCase());
                    if (!priceVariation) {
                        if (variationSize === "Grande") {
                            priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === "normale");
                        }
                        else if (variationSize === "Normale") {
                            priceVariation = ingredient.price_variations.find((pv) => pv.size?.toLowerCase() === "unique");
                        }
                    }
                    if (!priceVariation && ingredient.price_variations.length > 0) {
                        priceVariation = ingredient.price_variations[0];
                    }
                    if (priceVariation && typeof priceVariation.price === "number") {
                        return priceVariation.price;
                    }
                }
                if (ingredient.extra_cost_price !== undefined) {
                    return typeof ingredient.extra_cost_price === "number"
                        ? ingredient.extra_cost_price
                        : parseFloat(ingredient.extra_cost_price) || 0;
                }
                return 0;
            };
            return props.ingredients
                .filter((ing) => ing.is_available !== false && ing.is_available !== 0)
                .map((ing) => {
                const defaultPrice = getIngredientPriceForSize(ing, currentPizzaSelectedSize.value || "Normale");
                return {
                    id: ing.id,
                    name: ing.name,
                    price: defaultPrice,
                    image: ing.image_url || ing.imageUrl || "/images/ingredients/default.png",
                    selected: !!(ing.is_default === true || ing.is_default === 1),
                    isDefault: !!(ing.is_default === true || ing.is_default === 1),
                    price_variations: ing.price_variations || [],
                    type: ing.type,
                };
            });
        });
        const currentPizzaProductId = ref("");
        const currentPizzaProduct = ref(null);
        const currentPizzaSelectedSize = ref(null);
        function handleAddToCart(product) {
            const transformedProduct = transformProduct(product);
            const selectedSize = getSelectedSize(product);
            if (isCreateYourPizzaCategory(product)) {
                if (product.productSizes && product.productSizes.length > 0) {
                    createPizzaSizes.value = product.productSizes.map(transformProductSize);
                }
                currentPizzaProduct.value = product;
                currentPizzaProductId.value = product.id;
                currentPizzaSelectedSize.value = selectedSize;
                showCreatePizzaModal.value = true;
                return;
            }
            if (transformedProduct.additionnal &&
                transformedProduct.additionnal.length > 0) {
                additionalModalProduct.value = transformedProduct;
                additionalModalSize.value = selectedSize;
                showAdditionalModal.value = true;
                return;
            }
            handleQuickAdd(product, transformedProduct);
        }
        function handleAdditionalModalClose() {
            showAdditionalModal.value = false;
            additionalModalProduct.value = null;
            additionalModalSize.value = null;
        }
        function handleAdditionalAddToCart(event) {
            emit("add-to-cart", {
                product: event.product,
                size: event.size,
                quantity: event.quantity,
                ingredients: event.product.ingredients
                    ?.filter((ing) => ing.isDefault)
                    .map((ing) => ({
                    id: ing.id,
                    name: ing.name,
                    extra_cost_price: ing.price,
                    quantity: 1,
                    isDefault: ing.isDefault,
                })) || [],
                supplements: [],
                additionnal: event.additionnal,
                notes: event.notes || "",
            });
            handleAdditionalModalClose();
        }
        function handleBaseSupplementsModalClose() {
            showBaseSupplementsModal.value = false;
            baseSupplementsModalProduct.value = null;
            baseSupplementsModalSize.value = null;
        }
        function handleBaseSupplementsAddToCart(event) {
            emit("add-to-cart", {
                product: event.product,
                size: event.size,
                quantity: event.quantity,
                ingredients: event.product.ingredients
                    ?.filter((ing) => ing.isDefault)
                    .map((ing) => ({
                    id: ing.id,
                    name: ing.name,
                    extra_cost_price: ing.price,
                    quantity: 1,
                    isDefault: ing.isDefault,
                })) || [],
                supplements: event.supplements || [],
                additionnal: event.additionnal || [],
                notes: event.notes || "",
            });
            handleBaseSupplementsModalClose();
        }
        function handleCreatePizzaAddToCart(event) {
            emit("add-to-cart", event);
            showCreatePizzaModal.value = false;
        }
        function handleCreatePizzaClose() {
            showCreatePizzaModal.value = false;
            currentPizzaSelectedSize.value = null;
        }
        const getSizeInCm = (size) => {
            const sizeMap = {
                Petite: "24cm",
                Normale: "33cm",
                Grande: "40cm",
            };
            return sizeMap[size] || "33cm";
        };
        const extractPizzaSizesFromProducts = (products) => {
            const pizzaProduct = products.find((product) => {
                const cat = product.categorieID;
                return ((Number(cat?.prio) === 1 ||
                    cat?.prio === true ||
                    cat?.is_recommended === 1 ||
                    cat?.is_recommended === true ||
                    cat?.name?.toLowerCase().includes("pizza")) &&
                    product.productSizes &&
                    product.productSizes.length > 0);
            });
            if (pizzaProduct && pizzaProduct.productSizes) {
                createPizzaSizes.value =
                    pizzaProduct.productSizes.map(transformProductSize);
            }
        };
        watch(() => props.products, (newProducts) => {
            if (newProducts) {
                extractPizzaSizesFromProducts(newProducts);
                newProducts.forEach((product) => {
                    if (!selectedSizes.value[product.id] &&
                        product.productSizes &&
                        product.productSizes.length > 0) {
                        const transformedSizes = product.productSizes.map(transformProductSize);
                        const defaultSize = getDefaultSize(transformedSizes);
                        if (defaultSize) {
                            selectedSizes.value[product.id] = defaultSize;
                        }
                    }
                });
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "loading-spinner" }, null, -1)),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('common.loadingProducts')), 1)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: "product-card divers-card",
                            onClick: _cache[0] || (_cache[0] = ($event) => (showDiversModal.value = true))
                        }, [
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "product-image divers-image" }, [
                                _createElementVNode("div", { class: "divers-icon" }, "➕")
                            ], -1)),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('pos.divers') || 'Article Divers'), 1),
                                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('pos.customPrice') || 'Prix libre'), 1),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("button", _hoisted_9, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.add')), 1)
                                    ])
                                ])
                            ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (product) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: product.id,
                                class: "product-card"
                            }, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("img", {
                                        src: getProductImage(product),
                                        alt: product.name,
                                        class: "product-img"
                                    }, null, 8, _hoisted_11),
                                    (product.type && product.type.toLowerCase().includes('gluten'))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _cache[4] || (_cache[4] = _createTextVNode(" 🌾 ", -1)),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('pos.glutenFree')), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("h3", _hoisted_14, _toDisplayString(product.name), 1),
                                    (product.description)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(htmlToText)(product.description)), 1))
                                        : _createCommentVNode("", true),
                                    (shouldShowCustomizeButton(product))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createElementVNode("button", {
                                                onClick: ($event) => (handleCustomize(product)),
                                                class: "customize-btn"
                                            }, [
                                                _createElementVNode("span", null, _toDisplayString(getCustomizeButtonText(product)), 1)
                                            ], 8, _hoisted_17)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (hasSizes(product))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createElementVNode("div", _hoisted_19, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSortedProductSizes(product), (size) => {
                                                    return (_openBlock(), _createElementBlock("button", {
                                                        key: size.id,
                                                        onClick: ($event) => (handleSizeSelection(product, size)),
                                                        class: _normalizeClass([
                                                            'size-btn',
                                                            { selected: getSelectedSize(product)?.id === size.id },
                                                        ])
                                                    }, [
                                                        _createElementVNode("span", _hoisted_21, _toDisplayString(size.size), 1)
                                                    ], 10, _hoisted_20));
                                                }), 128))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("span", _hoisted_24, _toDisplayString(formatPrice(productPrices.value[product.id] || 0)), 1),
                                            (currentOrderType.value === 'delivery')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Prix de Livraison* "))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("button", {
                                                onClick: ($event) => (handleAddToCart(product)),
                                                class: "add-to-cart-btn"
                                            }, [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('pos.add')), 1)
                                            ], 8, _hoisted_27)
                                        ])
                                    ])
                                ])
                            ]));
                        }), 128)),
                        (filteredProducts.value.length === 0 && !isPizzaCategory.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "empty-icon" }, "🔍", -1)),
                                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('pos.noProductsFound')), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t('pos.tryChangeSearchOrCategory')), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ])),
                (showAdditionalModal.value)
                    ? (_openBlock(), _createBlock(AdditionalFeaturesModal, {
                        key: 2,
                        visible: showAdditionalModal.value,
                        product: additionalModalProduct.value,
                        selectedSize: additionalModalSize.value,
                        onClose: handleAdditionalModalClose,
                        onAddToCart: handleAdditionalAddToCart
                    }, null, 8, ["visible", "product", "selectedSize"]))
                    : _createCommentVNode("", true),
                (showBaseSupplementsModal.value)
                    ? (_openBlock(), _createBlock(BaseSupplementsModal, {
                        key: 3,
                        visible: showBaseSupplementsModal.value,
                        product: baseSupplementsModalProduct.value,
                        selectedSize: baseSupplementsModalSize.value,
                        onClose: handleBaseSupplementsModalClose,
                        onAddToCart: handleBaseSupplementsAddToCart
                    }, null, 8, ["visible", "product", "selectedSize"]))
                    : _createCommentVNode("", true),
                (showCreatePizzaModal.value)
                    ? (_openBlock(), _createBlock(CreatePizzaModal, {
                        key: 4,
                        visible: showCreatePizzaModal.value,
                        sizes: createPizzaSizes.value,
                        ingredients: createPizzaIngredients.value,
                        "all-ingredients": props.ingredients || [],
                        productId: currentPizzaProductId.value,
                        product: currentPizzaProduct.value,
                        "initial-selected-size": currentPizzaSelectedSize.value,
                        onClose: handleCreatePizzaClose,
                        onAddToCart: handleCreatePizzaAddToCart
                    }, null, 8, ["visible", "sizes", "ingredients", "all-ingredients", "productId", "product", "initial-selected-size"]))
                    : _createCommentVNode("", true),
                (showDiversModal.value)
                    ? (_openBlock(), _createBlock(DiversItemModal, {
                        key: 5,
                        visible: showDiversModal.value,
                        onClose: _cache[1] || (_cache[1] = ($event) => (showDiversModal.value = false)),
                        onConfirm: handleDiversConfirm
                    }, null, 8, ["visible"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
